import React, { Fragment } from "react"
import { observer } from "mobx-react"

import { getValue } from "../../helperFunctions"
import styles from "./styles"

import { Stack, Typography, Divider } from "@mui/material"
import { ButtonRow } from ".."

const TableEntry= ({ entries, updateEntries, entry, rows, mobileConfig }) => {
	const mobileOnly = mobileConfig?.mobileOnly
	const allowEmptyRows = mobileConfig?.allowEmptyRows

	const allowedTypes = ["button", "spacing"]
	const allowedValues = [false, 0]

	rows = rows?.filter((row) => {
		let { accessor, type, disableRender } = row

		if (typeof disableRender === "function") disableRender = disableRender({ data: entries, original: entry })
		if (disableRender) return false

		const value = getValue({ entry, accessor, type })
		if (!allowEmptyRows && !allowedTypes.includes(type) && !allowedValues.includes(value) && !value) return false

		return true
	})

	return (
		<Stack spacing="10px" sx={styles.container(mobileOnly)}>
			{rows?.map((row, index) => {
				const { Header: label, accessor, type, Cell: custom } = row
				const value = getValue({ entry, accessor, type })

				if (type === "spacing") return <Stack sx={styles.spacing} />
				else if (type === "button") {
					const buttonRow = { entries, updateEntries, entry, row }
					return <ButtonRow key={index} {...buttonRow} />
				}

				return (
					<Fragment key={index}>
						<Stack direction="row" spacing="10px" sx={styles.row}>
							<Typography variant="body1" sx={styles.label}>
								{label}
							</Typography>

							{type === "custom" && (
								<Stack sx={{ width: "50%" }}>{custom({ value, cell: { row: { original: entry } } })}</Stack>
							)}

							{type !== "custom" && (
								<Typography variant="body1" sx={styles.value}>
									{value}
								</Typography>
							)}
						</Stack>

						{index !== rows?.length - 1 && <Divider sx={styles.divider} />}
					</Fragment>
				)
			})}
		</Stack>
	)
}

export default observer(TableEntry)
